import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Backend error details are a string OR a dict ({message, errors?}) OR a list (FastAPI 422).
// Rendering a non-string in toast/JSX throws "Objects are not valid as a React child" and
// blanks the whole app — always route error details through here.
export function apiErr(e, fallback) {
  const d = e.response?.data?.detail;
  if (typeof d === "string" && d) return d;
  if (typeof d?.message === "string") return d.message;
  return fallback;
}

export async function downloadSkillZip(skillId, slug) {
  const res = await fetch(`${API}/skills/${skillId}/download`, { credentials: "include" });
  if (!res.ok) {
    let detail = "Download failed";
    try {
      detail = (await res.json()).detail || detail;
    } catch (e) {
      console.warn("[api] could not parse download error body", e);
    }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${slug || "skill"}.zip`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
